














import Vue from 'vue'
import moment from 'moment'

export default Vue.extend({
  name: 'DataItem',
  props: [ 'event', 'time', 'type' ]
});
